import { useState, useLayoutEffect } from 'react';

const getWidth = (key) => {
  const elementFound = document.querySelector(key);
  if (elementFound) {
    const { width } = elementFound.getBoundingClientRect();
    return width;
  }

  return 0;
};

const useGetWidthByElement = (key = '') => {
  const [width, setWidth] = useState(getWidth(key));

  useLayoutEffect(() => {
    const handler = () => {
      const width = getWidth(key);
      setWidth(width);
    };

    handler();
    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [key]);

  return width;
};

export default useGetWidthByElement;
